angular.module('wbDashboard').controller('FundingControllerAurea', ['$scope', '$uibModal', '$filter', 'User', 'Account', 'PlanService', function ($scope, $uibModal, $filter, User, Account, PlanService) {

    $scope.pageData = {
        sending: false,
        errorMsg: null,
        showContributions : false
    };

    $scope.validation = {};
    $scope.forms = {};
    $scope.auto = {
        auto_deposits : {}
    };
    $scope.milestones = {};

    $scope.$watch(User.getOverview, function(overview) {
        $scope.overview = overview;
    });


    PlanService.user.retrieveRollovers();
    $scope.$watch(function() { return PlanService.user.getRollovers(); }, function(rollovers) {
        var pending = false;
        var allDone = true;
        angular.forEach(rollovers, function(r) {
            if (['upload-statement', 'liquidate', 'add-retirement', 'add-ira', 'fill-out-form', 'contact-firm'].indexOf(r.status) > -1) {
                pending = true;
            }
            if (r.status !== 'complete') {
                allDone = false;
            }
        });
        $scope.rolloversPending = pending;
        $scope.rolloversComplete = allDone;
        $scope.rollovers = rollovers;
    });


    $scope.$watch(function() { return PlanService.user.getAutos(); }, function(autos) {
        $scope.autos = autos;
    });

	User.retrieveBankAccounts();
	$scope.$watch(User.getBankAccounts, function(bankAccounts) {
		if (bankAccounts) {
            $scope.bankAccounts = bankAccounts;
            $scope.bankAccounts.current = $scope.bankAccounts.pending || $scope.bankAccounts.active;

        }
	});

    //determine max withdrawal value that doesn't close account
    $scope.getMax = function(marketValue, delta = 0) {
        var max = 50000;

        if (marketValue < 1) {
            //From market_value < 20, minimum withdrawal is entire balance
            max = marketValue;
        } else if (marketValue < max - delta) {
            max = marketValue - delta;
        }
        return max;
    };

    $scope.validation.max = function(value, transaction) {
        var marketValue;
        if (transaction.from && transaction.from.milestone) {
            marketValue = transaction.from.value;
        }
        return !value || value <= $scope.getMax(marketValue, 0);
    };

    $scope.validation.min = function(value, transaction) {
        var min = 1; //10
        if (transaction.from && transaction.from.milestone) {
            if (value > 0 && transaction.from.value === value) {
                return true;
            }
        }
        if (typeof value === "undefined") return true;
        return value >= min;
    };

}]);
